// extracted by mini-css-extract-plugin
module.exports = {"stylish":"number-circle_stylish__6BwfK","inactive":"number-circle_inactive__1zay8"};